import store from '@/store';
import Env from '@/env';
import isEmpty from 'lodash/isEmpty';
/**
 * Check if token exist or not, if not redirect back to login page
 */
export default function activebusiness({ next, router, to}) {
    let activeBusiness = store.getters['location/selected'];
    if (!isEmpty(activeBusiness)) {
      // if token push to SelectBusiness
      return router.push({ name: 'ReportDashboard' });
    }
    return next();
}